module.exports = __webpack_public_path__ + "static/media/ketchup.4739012b.png";